import React, { useState } from 'react';
import { connect } from 'react-redux';
import SpeechIncorrect from './clozeSpeechFeedback';
import SpeedDetailedFeedback from '../saFeedback/speechDetailedFeedback';
import ClozeConvoFeedback from '../../utils/feedback/clozeConvoFeedback';

import { compose } from 'redux';
import FeedbackLayout from '../../utils/feedback/feedbackLayout';

const ClozeConversationFeedback = ({
	rightFeedbackProps: { defaultFeedback, score, fileUrl, correctAnswer },
	leftFeedbackProps: { selectedAnswer, passage },
}) => {
	let UserAndCorrectAnswerList = '';
	let correctAnswers = correctAnswer.split('#');
	const [showFeedback, setShowFeedBack] = useState(false);

	UserAndCorrectAnswerList = fileUrl
		.split('|')
		.map((val, key) => (
			<SpeechIncorrect
				fileUrl={val}
				correctAnswer={correctAnswers[key]}
				selectedAnswer={selectedAnswer[key]}
				index={key}
				score={score}
			/>
		));

	return (
		<section className="quiz-area-options">
			{score >= 0.4 && !showFeedback ? (
				<span id="answerAccordion">
					<h4 className="text-success">That's Correct</h4>
					<span id="seeAnswerConvo" onClick={() => setShowFeedBack(true)}>
						See Explanation
					</span>
				</span>
			) : (
				<span id="conversationFeedback">
					<ClozeConvoFeedback
						correctAnswer={correctAnswers}
						selectedAnswer={selectedAnswer}
						passage={passage}
					/>

					<div>
						{' '}
						<hr />
						<h4> Your Recorded answers: </h4>
						{UserAndCorrectAnswerList}
					</div>
					{!!defaultFeedback &&
						Object.keys(defaultFeedback).includes('accuracy') && (
							<SpeedDetailedFeedback />
						)}
					{!!defaultFeedback && !Object.keys(defaultFeedback).includes('accuracy') && (
						<div class="tutor-feedback">
							<i class="fa fa-comments-o" aria-hidden="true"></i>
							<p>
								<span>Feedback</span>
								{defaultFeedback}
							</p>
						</div>
					)}
					<input type="hidden" name="choosen-answer" className="choosen-answer" />
				</span>
			)}
		</section>
	);
};

const mapStateToProps = (state) => {
	const {
		rightFeedbackProps,
		leftFeedbackProps,
		questionNo,
	} = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		questionNo,
		leftFeedbackProps,
	};
};

export default compose(
	FeedbackLayout,
	connect(mapStateToProps, null),
)(ClozeConversationFeedback);
